import React, { useState, useEffect, useContext } from 'react';
import moment from 'moment';
// import { QuantaConfigContext } from '../../../../../../lib/config/ConfigProvider';
// import CurrencyFormater from '../../../../../../lib/intl/CurrencyFormater';
// import useFetchQuery from '../../../../../../lib/graphql/useFetchQuery';
import {
  QuantaConfigContext,
  CurrencyFormater,
  useFetchQuery,
} from 'quanta-flows';
import { useQuery } from '@apollo/client';

// import {
//   PIN_CODE_LOOKUP,
//   CUSTOMER_DROPDOWN_DETAILS,
// } from '../../queries';
import {
  PIN_CODE_LOOKUP,
  CUSTOMER_DROPDOWN_DETAILS,
  COVER_TYPE_LIMIT,
  QUERY_STATE,
} from 'quanta-flows/modules/quote/health';

import {
  initHealthPlansState,
  updateHealthQuote,
} from 'quanta-flows/modules/quote/health/state';
import { healthQuoteVar } from 'quanta-flows/modules/quote/health/state';
// import { initHealthPlansState, updateHealthQuote } from '../../_graphql/state';
// import { healthQuoteVar } from '../../_graphql/state';
// import Loading from '../../../../../../lib/layout/loading';
// import Error from '../../../../../../lib/layout/error';
import { Loading } from 'quanta-flows/modules/layout';
import { Error } from 'quanta-flows/modules/layout';

import {
  Text,
  Label,
  useResponsiveParams,
  Button,
  QuantaFormik,
  QuantaForm,
  useQuantaFormikContext,
  InputGridGroup,
  Grid,
  GridItem,
  QuantaSelect,
  QuantaDateInput,
} from 'quanta-ui';

//import ModalAddOthers from './modal-add-others';
import { ModalAddOthers } from 'quanta-flows/modules/quote/health';
import {
  faCheckCircle,
  faPlus,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Members({
  setProceedToPlanPage,
  setAlerts,
  productDetails,
  genderList,
  quoteNumber,
  productCode,
  productName,
  lobCode,
  setStartStep,
  ...props
}) {
  let fetchQuery = useFetchQuery();
  let repeatForMobile = 1;
  let repeatForDesktop = 4;
  const { branding } = useContext(QuantaConfigContext);
  // let healthQuote = healthQuoteVar();
  //const [initialValues] = useState(healthQuote);
  let [loadingPinCode, setLoadingPinCode] = useState(false);
  let [showModalAddOthers, setShowModalAddOthers] = useState(false);
  const initialMemberList = [
    {
      label: 'Self',
      gender: null,
      selectGender: true,
      maxAllowed: 1,
      selected: false,
    },
    {
      label: 'Spouse',
      gender: null,
      selectGender: true,
      maxAllowed: 1,
      selected: false,
    },
    {
      label: 'Father',
      gender: 'MALE',
      selectGender: false,
      maxAllowed: 1,
      selected: false
    },
    {
      label: 'Mother',
      gender: 'FEMALE',
      selectGender: false,
      maxAllowed: 1,
      selected: false
    },
  ];
  const [memberList, setMemberList] = useState(initialMemberList);


  const repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });

  const screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
          });
   const { loading, error, data } = useQuery(QUERY_STATE);

  const {
    loading: loadingBusinessType,
    error: errorBusinessType,
    data: businessTypeData,
  } = useQuery(CUSTOMER_DROPDOWN_DETAILS, {
    fetchPolicy: 'cache-first',
  });
  const {
    loading: loadingCoverType,
    error: errorCoverType,
    data: coverTypeData,
  } = useQuery(COVER_TYPE_LIMIT, {
    fetchPolicy: 'cache-first',
  });


  const {
    applicableMemberTypes,
    applicableZones,
    applicableCoverTypes,
    applicableSumInsureds,
    applicableTenures,
  } = productDetails;

  useEffect(() => {
    if (data) {
      const healthQuote = data?.healthQuote;
      let membersListCopy = [...memberList];
      if (healthQuote?.quotationNo) {
        membersListCopy = [];
        healthQuote.members.forEach((mem) => {
          membersListCopy.push({
            label: mem.relationship,
            gender: genderList.find(
              (g) =>
                g.code.toLowerCase() === mem.gender.toLowerCase() ||
                g.value.toLowerCase() === mem.gender.toLowerCase(),
            )
              ? mem.gender
              : '',
            selectGender: false,
          });
        });
      } else {
        healthQuote.members.forEach((mem) => {
          if (
            mem.relationship !== 'Self' &&
            mem.relationship !== 'Spouse' &&
            mem.relationship !== 'Father' &&
            mem.relationship !== 'Mother'
          ) {
            if (
              membersListCopy?.find(
                (memCopy) =>
                  memCopy?.label?.toString()?.toLowerCase() ===
                  mem?.relationship?.toString()?.toLowerCase(),
              )
            ) {
              const memCopyIndex = membersListCopy?.findIndex(
                (memCopy) =>
                  memCopy?.label?.toString()?.toLowerCase() ===
                  mem?.relationship?.toString()?.toLowerCase(),
              );
              membersListCopy = [
                ...membersListCopy?.slice(0, memCopyIndex),
                {
                  ...membersListCopy[memCopyIndex],
                },
                ...membersListCopy?.slice(memCopyIndex + 1),
              ];
            } else {
              membersListCopy.push({
                label: mem.relationship,
                gender: genderList.find(
                  (g) =>
                    g.code.toLowerCase() ===
                      mem.gender.toLowerCase() ||
                    g.value.toLowerCase() ===
                      mem.gender.toLowerCase(),
                )
                  ? mem.gender
                  : '',
                selectGender: applicableMemberTypes?.find((addMem) =>
                  mem?.relationship?.startsWith(addMem?.label),
                )?.selectGender,
              });
            }
          }
        });
      }
      setMemberList(membersListCopy);
    }
  }, [data]);
  if (loadingBusinessType || loadingCoverType || loading) {
  
    return (
      <div className="h-screen">
        <Loading />
      </div>
    );
  }
  if (errorBusinessType || errorCoverType || error) {
    return (
      <Error error={errorBusinessType || errorCoverType || error} />
    );
  }
  const { businessTypeList } = businessTypeData;
  const { maxInsuredLimitList } = coverTypeData;
  const MINOR_THRESHOLD_AGE=18;
  
   const { healthQuote } = data;

  const validate = (values) => {
    const errors = {};
    const maxInsuredIndividualValue = maxInsuredLimitList?.find(
      (maxLimit) =>
        maxLimit.code.toLowerCase() === 'individual basis',
    );
    const maxInsuredFloaterValue = maxInsuredLimitList?.find(
      (maxLimit) => maxLimit.code.toLowerCase() === 'floater basis',
    );

    if (!values.quotationType || values.quotationType === '') {
      errors.quotationType = '* Required';
    }


//     if (values.members[1].gender===values.members[0].gender)
// {
// errors.members = [{},{ gender: '* Self and Spouse Gender cannot be same' }];
// }


if (values.members[1].gender===values.members[0].gender && values.members[0].gender && values.members[1].gender)
    {
      errors.members = [{},{ gender: '* Self and Spouse Gender cannot be same' }];
    }
    if (values.members.filter((mem) => mem.selected).length === 0) {
      errors.members = [{ selected: '* Please select a member' }];
    } else if (
      values.members.filter(
        (mem) =>
          mem.selected &&
          (!mem.gender ||
            mem.gender === '' ||
            !mem.dob ||
            mem.dob === ''),
      ).length > 0
    ) {
      errors.members = values.members.map((mem) => {
        return {
          gender:
            mem.selected && (!mem.gender || mem.gender === '')
              ? '* Required'
              : '',
          dob:
            mem.selected && (!mem.dob || mem.dob === '')
              ? '* Required'
              : '',
        };
      });
    } else if (
      values.members.filter(
        (mem) =>
          mem.selected &&
          mem.dob !== '' &&
          moment(mem.dob, 'DD/MM/YYYY').isAfter(),
      ).length > 0
    ) {
      errors.members = values.members.map((mem) => {
        return {
          dob:
            mem.selected &&
            mem.dob !== '' &&
            moment(mem.dob, 'DD/MM/YYYY').isAfter()
              ? '* Date of Birth cannot be in the future'
              : '',
        };
      });
    }
    else if (
      values.members.filter(
        (mem) =>
          mem.selected &&
          mem.relationship.toString() ==='Self' && 
          mem.dob !== '' && 
          (moment(new Date(), 'DD/MM/YYYY').diff(
            moment(mem.dob, 'DD/MM/YYYY'),
            'years')) < MINOR_THRESHOLD_AGE
    ).length>0)
    {
      errors.members = values.members.map((mem) => {
        // console.log("mem ", mem);
        return {
          dob:
            mem.selected &&  mem.relationship.toString() ==='Self' && mem.dob !== '' &&
             ( moment(new Date(), 'DD/MM/YYYY').diff(
                moment(mem.dob, 'DD/MM/YYYY'),
                'years')) < MINOR_THRESHOLD_AGE
              ? '* Date of Birth cannot be less than 18'
              : '',
        };
      });
    }


    else if (
      values.members.filter(
        (mem) =>
          mem.selected &&
          mem.relationship.toString() ==='Adult Son' && 
          mem.dob !== '' && 
          (moment(new Date(), 'DD/MM/YYYY').diff(
            moment(mem.dob, 'DD/MM/YYYY'),
            'years')) < MINOR_THRESHOLD_AGE
    ).length>0)
    {
      errors.members = values.members.map((mem) => {
        // console.log("mem ", mem);
        return {
          dob:
            mem.selected &&  mem.relationship.toString() ==='Adult Son' && mem.dob !== '' &&
             ( moment(new Date(), 'DD/MM/YYYY').diff(
                moment(mem.dob, 'DD/MM/YYYY'),
                'years')) < MINOR_THRESHOLD_AGE
              ? '* Date of Birth cannot be less than 18'
              : '',
        };
      });
    }

    if (!values.location.pincode || values.location.pincode === '') {
      errors.location = {
        ...errors.location,
        pincode: '* Required',
      };
    } else if (
      values.location.pincode.toString().length !== 6 ||
      !values.location.pincode.toString().match(/^[0-9]+$/)
    ) {
      errors.location = {
        ...errors.location,
        pincode: '* Pincode must be of 6 digits',
      };
    } else if (
      values.location.pincode &&
      (!values.location.city ||
        !values.location.district ||
        !values.location.state)
    ) {
      errors.location = {
        ...errors.location,
        pincode: '* Please click on the Pincode Search Icon',
      };
    }

    // if (!values.location.zone || values.location.zone === '') {
    //   errors.location = { ...errors.location, zone: '* Required' };
    // }

    if (!values.cover.type || values.cover.type === '') {
      errors.cover = { ...errors.cover, type: '* Required' };
    }

    if (
      !values.cover.sum_insured ||
      values.cover.sum_insured === ''
    ) {
      errors.cover = { ...errors.cover, sum_insured: '* Required' };
    }

    if (!values.cover.tenure || values.cover.tenure === '') {
      errors.cover = { ...errors.cover, tenure: '* Required' };
    }
    return errors;
  };

  const onSubmit = (values) => {
    const errors = validate(values);
    const error_count = Object.keys(errors).length;
    if (error_count === 0) {
      updateHealthQuote({ ...values, currentTab: 'plans' });
      if (!healthQuote?.quotationNo && !quoteNumber) {
        initHealthPlansState();
      }
      setProceedToPlanPage(true);
      setStartStep(1);
      setAlerts([]);
      return true;
    } else {
      setProceedToPlanPage(false);
      return false;
    }
  };

  const MemberForm = ({ validate }) => {
    const { values, setFieldValue } = useQuantaFormikContext();
    const isAllowed = (memberType) => {
      let isPresent = values.members.filter((mem) =>
        memberType.maxAllowed > 1
          ? mem.relationship.startsWith(memberType.label)
          : mem.relationship === memberType.label,
      );
      return isPresent.length < memberType.maxAllowed &&
        memberType.label !== 'Self' &&
        memberType.label !== 'Spouse'
        ? true
        : false;
    };
    useEffect(() => {
      if (
        values &&
        values.members.filter((mem) => mem.selected).length === 1
      ) {
        setFieldValue('cover.type', 'Individual Basis');
      }
    }, [values.members]);
    const AutoSubmitForm = ({ validate, values }) => {
      useEffect(() => {
        if (values) {
          const errors = validate(values);
          const error_count = Object.keys(errors).length;
          if (error_count === 0) {
            onSubmit(values);
          }
        }
      }, [values]);
      return null;
    };

    const onPinCodeLookup = async (val, setFieldValue) => {
      if (
        !(
          val.toString().length !== 6 ||
          !val.toString().match(/^[0-9]+$/)
        )
      ) {
        let queryOutput = fetchQuery({
          query: PIN_CODE_LOOKUP,
          variables: {
            filter: {
              pincode: val,
              },
            },
        });
        setLoadingPinCode(true);
        try {
          setAlerts([]);
          let { data } = await queryOutput;
          setLoadingPinCode(false);
          setFieldValue('location.city', data.pincodeInfo.city);
          setFieldValue(
            'location.district',
            data.pincodeInfo.district,
          );
          setFieldValue('location.state', data.pincodeInfo.state);
        } catch (error) {
          setLoadingPinCode(false);
          setAlerts([
            {
              header: 'Pincode Search Failed',
              id: Date.now(),
              content: (
                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                  <span>{error.message}</span>
                </div>
              ),
              type: 'error',
              timeout: null,
              disableClose: false,
            },
          ]);
          window.scrollTo({ top: 0, behavior: 'smooth' });
          setFieldValue('location.city', '');
          setFieldValue('location.district', '');
          setFieldValue('location.state', '');
        }
      }
    };

    const data = [
      {
        title: 'Choose Business Type',
        grid_data: [
          {
            colSpan: repeat,
            disabledGlobal: values?.quotationNo !== '',
            type: 'radiogroup',
            name: 'quotationType',
            itemBreak: repeat === repeatForMobile,
            data: businessTypeList
              ? [
                  ...businessTypeList.map((businessType) => {
                    return {
                      label: businessType.value
                        ? businessType.value
                        : '',
                      value: businessType.code
                        ? businessType.code
                        : '',
                    };
                  }),
                ]
              : [],
          },
        ],
      },
      {
        title: 'Choose Members',
        grid_data:
          memberList.length > 0 && 
          screenType?.toString()?.toLowerCase() === 'mobile'
            ? [
                {
                  type: 'render',
                  component: (values) => {
                    return (
                      <React.Fragment>
                        {memberList.map((mem, idx) => {
                          const dateVal = values?.members[idx]?.dob;
                          return (
                            <Grid
                              key={idx}
                              flow={'cols'}
                              repeat={3}
                              gap={2}
                              className="py-0.5"
                            >
                              <GridItem colSpan={1}>
                                <Button
                                  className={`text-black m-0 hover:bg-white focus:text-black focus:bg-white focus:outline-none w-full h-5/6 relative p-1 flex flex-col items-center justify-center rounded-lg text-xs cursor-pointer ${
                                    values?.members[idx]?.selected
                                      ? 'border-2 border-secondary'
                                      : 'border border-secondary bg-opacity-50'
                                  }`}
                                  flat={true}
                                  type="button"
                                  disabled={
                                    values?.quotationNo !== ''
                                  }
                                  onClick={(_) => {
                                    setFieldValue(
                                      `members[${idx}].selected`,
                                      !values?.members[idx]?.selected,
                                    );
                                  }}
                                >
                                  <div className="flex flex-col h-full w-full items-center justify-center text-black">
                                  <Text
                                      className={
                                        !initialMemberList?.find(
                                          (initialMember) =>
                                            initialMember?.label
                                              ?.toString()
                                              ?.toLowerCase() ===
                                            mem?.label
                                              ?.toString()
                                              ?.toLowerCase(),
                                        ) && !values?.quotationNo
                                          ? 'mt-4'
                                          : ''
                                      }
                                    >
                                      {mem.label}
                                    </Text>  
                                    <Text type="label">
                                      {dateVal
                                        ? `${moment().diff(
                                            moment(
                                              dateVal,
                                              'DD/MM/YYYY',
                                            ),
                                            'years',
                                          )} Year(s)`
                                        : null}
                                    </Text>
                                    {!initialMemberList?.find(
                                      (initialMember) =>
                                        initialMember?.label
                                          ?.toString()
                                          ?.toLowerCase() ===
                                        mem?.label
                                          ?.toString()
                                          ?.toLowerCase(),
                                    ) && !values?.quotationNo && (
                                      <Text
                                        severity={'info'}
                                        type={'label'}
                                        className={
                                          'rounded hover:bg-secondary hover:text-white'
                                        }
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setFieldValue('members', [
                                            ...values?.members?.slice(
                                              0,
                                              idx,
                                            ),
                                            ...values?.members?.slice(
                                              idx + 1,
                                            ),
                                          ]);
                                          setMemberList([
                                            ...memberList?.slice(
                                              0,
                                              idx,
                                            ),
                                            ...memberList?.slice(
                                              idx + 1,
                                            ),
                                          ]);
                                        }}
                                      >
                                        Remove
                                      </Text>
                                    )}
                                  </div>
                                  <div
                                    className={
                                      values?.members[idx]?.selected
                                        ? !values?.quotationNo
                                          ? 'absolute top-1 right-1 text-secondary'
                                          : 'absolute top-1 right-1 text-neutral-dark'
                                        : 'hidden'
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={faCheckCircle}
                                    />
                                  </div>
                                </Button>
                              </GridItem>
                              <GridItem colSpan={2}>
                                <div>
                                  <QuantaSelect
                                    size="full"
                                    name={`members[${idx}].gender`}
                                    data={genderList.map((gender) => {
                                      return {
                                        label: gender?.value
                                          ? gender?.value?.toString()
                                          : '',
                                        value: gender?.code
                                          ? gender?.code?.toString()
                                          : '',
                                      };
                                    })}
                                    disabled={
                                      !values?.members[idx]
                                        ?.selected ||
                                      !mem.selectGender ||
                                      values?.quotationNo !== ''
                                    }
                                    onDataChange={(
                                      val,
                                      setFieldValue,
                                    ) => {
                                      if (mem.label === 'Self') {
                                        setFieldValue(
                                          'members[1].gender',
                                          val === 'MALE'
                                            ? 'FEMALE'
                                            : 'FEMALE'
                                            ? 'MALE'
                                            : val,
                                        );
                                      }
                                    }}
                                  />
                                </div>
                                <div>
                                  <Text type="label">
                                    Date of Birth{' '}
                                    {values?.members[idx]
                                      ?.selected ? (
                                      <Text severity="error">*</Text>
                                    ) : null}
                                  </Text>
                                  <QuantaDateInput
                                    size="full"
                                    name={`members[${idx}].dob`}
                                    disabled={
                                      !values?.members[idx]
                                        ?.selected ||
                                      values?.quotationNo !== ''
                                    }
                                    onDataChange={(
                                      val,
                                      setFieldValue,
                                    ) =>
                                      setFieldValue(
                                        `members[${idx}].age`,
                                        moment().diff(
                                          moment(val, 'DD/MM/YYYY'),
                                          'years',
                                        ),
                                      )
                                    }
                                  />
                                </div>
                              </GridItem>
                              <GridItem colSpan={3} className="-mt-7">
                                {idx === 0 && (
                                  <Text type="label" severity="error">
                                    {validate(values)?.members
                                      ?.length > 0
                                      ? validate(values).members[0]
                                          ?.selected
                                      : null}
                                  </Text>
                                )}
                              </GridItem>
                            </Grid>
                          );
                        })}
                      </React.Fragment>
                    );
                  },
                },
                !values?.quotationNo &&
                applicableMemberTypes?.filter((applicable) =>
                  isAllowed(applicable),
                )?.length > 0
                  ? {
                      type: 'render',
                      colSpan: 1,
                      component: () => (
                        <div className="mb-2">
                          <Button
                            flat={false}
                            type="button"
                            className="w-full pl-4 max-h-10"
                            iconPre={
                              <FontAwesomeIcon icon={faPlus} />
                            }
                            onClick={(e) =>
                              setShowModalAddOthers(true)
                            }
                          >
                            Add Others
                          </Button>
                        </div>
                      ),
                    }
                  : null,
                  values?.members?.filter((mem) => mem.selected)
                  ?.length === 0
                  ? {
                      type: 'render',
                      colSpan: repeat,
                      component: () => {
                        return (
                          <Text severity={'error'}>
                            * Please select atleast 1 member
                          </Text>
                        );
                      },
                    }
                  : null,
              ].filter((d) => d !== null)
            : memberList.length > 0 && 
            screenType?.toString()?.toLowerCase() !== 'mobile'
            ? [
                ...memberList
                  .map((mem, idx) => [
                    {
                      type: 'checkbox',
                      disabled: values?.quotationNo !== '',
                      label: mem.label,
                      name: `members[${idx}].selected`,
                      className: 'mt-10',
                      onDataChange: (val, setFieldValue) => {
                        setFieldValue(
                          `members[${idx}].relationship`,
                          mem.label,
                        );
                      },
                    },
                    {
                      type: 'select',
                      label: (
                        <Text type="label">
                          Gender{' '}
                          {values?.members[idx]?.selected ? (
                            <Text severity="error">*</Text>
                          ) : null}
                        </Text>
                      ),
                      name: `members[${idx}].gender`,
                      disabled:
                        !values?.members[idx]?.selected ||
                        !mem.selectGender ||
                        values?.quotationNo !== '',
                      onDataChange: (val, setFieldValue) => {
                        if (mem.label === 'Self') {
                          setFieldValue(
                            'members[1].gender',
                            val === 'MALE'
                              ? 'FEMALE'
                              : 'FEMALE'
                              ? 'MALE'
                              : val,
                          );
                        }
                      },
                      data: genderList.map((gender) => {
                        return {
                          label: gender?.value
                            ? gender?.value?.toString()
                            : '',
                          value: gender?.code
                            ? gender?.code?.toString()
                            : '',
                        };
                      }),
                    },
                    {
                      type: 'date',
                      label: (
                        <Text type="label">
                          Date of Birth{' '}
                          {values?.members[idx]?.selected ? (
                            <Text severity="error">*</Text>
                          ) : null}
                        </Text>
                      ),
                      name: `members[${idx}].dob`,
                      disabled:
                        !values?.members[idx]?.selected ||
                        values?.quotationNo !== '',
                      onDataChange: (val, setFieldValue) =>
                        setFieldValue(
                          `members[${idx}].age`,
                          moment().diff(
                            moment(val, 'DD/MM/YYYY'),
                            'years',
                          ),
                        ),
                    },
                    {
                      type: 'render',
                      component: (values) => {
                        let value = values?.members[idx]?.dob;
                        return value === undefined || value === '' ? (
                          initialMemberList?.find((initialMember) =>
                            initialMember?.label?.startsWith(
                              mem?.label,
                            ),
                          ) ? null : (
                            <>
                              <Label
                                className="mb-2 h-6"
                                text=""
                              ></Label>
                              <div className="flex flex-row gap-2 items-center h-10">
                                <Text className="w-20 text-base"></Text>
                                {!initialMemberList?.find(
                                  (initialMember) =>
                                    initialMember?.label
                                      ?.toString()
                                      ?.toLowerCase() ===
                                    mem?.label
                                      ?.toString()
                                      ?.toLowerCase(),
                                ) &&
                                  !values?.quotationNo && (
                                    <Text>
                                      <FontAwesomeIcon
                                        icon={faTrashAlt}
                                        className={`cursor-pointer ${
                                          values?.quotationNo !== ''
                                            ? 'text-neutral-dark'
                                            : 'text-secondary'
                                        }`}
                                        size={'lg'}
                                        onClick={(_) => {
                                          if (
                                            values?.quotationNo === ''
                                          ) {
                                            setFieldValue('members', [
                                              ...values?.members?.slice(
                                                0,
                                                idx,
                                              ),
                                              ...values?.members?.slice(
                                                idx + 1,
                                              ),
                                            ]);
                                            setMemberList([
                                              ...memberList?.slice(
                                                0,
                                                idx,
                                              ),
                                              ...memberList?.slice(
                                                idx + 1,
                                              ),
                                            ]);
                                          }
                                        }}
                                      />
                                    </Text>
                                  )}
                              </div>
                            </>
                          )
                        ) : (
                          <>
                            <Label
                              className="mb-2"
                              text="Age"
                            ></Label>
                            <div className="flex flex-row gap-2 items-center h-10">
                            {values.members[idx]?.selected &&
                              mem.label !== '' ? (
                              <Text className="w-20 text-base">
                              {moment().diff(
                                moment(value, 'DD/MM/YYYY'),
                                'years',
                              )}{' '}
                              Years
                            </Text>
                            ) : mem.label === 'Self' || mem.label === 'Spouse' ?
                            ((values.members[idx].dob = ''),
                            (values.members[idx].gender = ''))
                            :(values.members[idx].dob = '')}
                            {!initialMemberList?.find(
                                (initialMember) =>
                                  initialMember?.label
                                    ?.toString()
                                    ?.toLowerCase() ===
                                  mem?.label
                                    ?.toString()
                                    ?.toLowerCase(),
                              ) &&
                                !values?.quotationNo && (
                                  <Text>
                                    <FontAwesomeIcon
                                      icon={faTrashAlt}
                                      className={`cursor-pointer ${
                                        values?.quotationNo !== ''
                                          ? 'text-neutral'
                                          : 'text-secondary'
                                      }`}
                                      size={'lg'}
                                      onClick={(_) => {
                                        if (
                                           values?.quotationNo === ''
                                          ) {
                                            setFieldValue('members', [
                                              ...values?.members?.slice(
                                                0,
                                                idx,
                                              ),
                                              ...values?.members?.slice(
                                                idx + 1,
                                              ),
                                            ]);
                                            setMemberList([
                                              ...memberList?.slice(
                                                0,
                                                idx,
                                              ),
                                              ...memberList?.slice(
                                                idx + 1,
                                              ),
                                            ]);
                                          }
                                        }}
                                      />
                                    </Text>
                                  )}
                          </div>
                          </>
                        );
                      },
                    },
                  ])
                  .reduce((b, a) => [...b, ...a])
                  .map((itm) => {
                    return { ...itm };
                  }),
                  !values?.quotationNo &&
                  applicableMemberTypes?.filter((applicable) =>
                    isAllowed(applicable),
                  )?.length > 0
                  ? {
                      type: 'render',
                      colSpan: 1,
                      component: () => (
                        <div className="mb-2">
                          <Button
                            flat={false}
                            type={'button'}
                            className="w-full pl-4 max-h-10"
                            iconPre={
                              <FontAwesomeIcon icon={faPlus} />
                            }
                            onClick={(e) =>
                              setShowModalAddOthers(true)
                            }
                          >
                            Add Others
                          </Button>
                        </div>
                      ),
                    }
                  : null,
                  values?.members?.filter((mem) => mem.selected)
                  ?.length === 0
                  ? {
                      type: 'render',
                      colSpan: repeat,
                      component: () => {
                        return (
                          <Text severity={'error'}>
                            * Please select atleast 1 member
                          </Text>
                        );
                      },
                    }
                  : null,
              ].filter((d) => d)
            : [],
      },
      {
        title: 'Choose Location',
        grid_data: [
          {
            type: 'input-lookup',
            size: 'large',
            loading: loadingPinCode,
            label: (
              <div>
                Pin Code <Text severity="error">*</Text>
              </div>
            ),
            name: 'location.pincode',
            onLookup: onPinCodeLookup,
            disabled: loadingPinCode || values?.quotationNo !== '',
            onDataChange: (_, setFieldValue) => {
              setFieldValue('location.state', '');
              setFieldValue('location.district', '');
              setFieldValue('location.city', '');
            },
            onKeyDown: (e) => {
              if (
                !e.key.match(/^[0-9]+$/) &&
                !['arrowleft', 'arrowright', 'backspace']?.includes(
                  e?.key?.toString()?.toLowerCase(),
                )
              ) {
                e.preventDefault();
              }
            },
          },
          {
            type: 'text',
            label: 'State',
            name: 'location.state',
            disabled: true,
          },
          {
            type: 'text',
            label: 'District',
            name: 'location.district',
            disabled: true,
          },
          {
            type: 'text',
            label: 'City/Town/Village',
            name: 'location.city',
            disabled: true,
          },
          // {
          //   type: 'select',
          //   disabled: values?.quotationNo !== '',
          //   label: (
          //     <div>
          //       Zone <Text severity="error">*</Text>
          //     </div>
          //   ),
          //   name: 'location.zone',
          //   data: applicableZones.map((zone) => {
          //     return {
          //       label: zone?.value ? zone?.value?.toString() : '',
          //       value: zone?.code ? zone?.code?.toString() : '',
          //     };
          //   }),
          // },
        ],
      },
      {
        title: 'Choose Cover',
        grid_data: [
          {
            type: 'select',
            label: (
              <div>
                Cover Type <Text severity="error">*</Text>
              </div>
            ),
            name: 'cover.type',
            disabled: values?.quotationNo !== '',
            data: applicableCoverTypes
              .filter((type) =>
                values.members.filter((member) => member.selected)
                  .length === 1
                  ? type.value !== 'Floater Basis'
                  : true,
              )
              .map((coverType) => {
                return {
                  label: coverType?.value
                    ? coverType?.value?.toString()
                    : '',
                  value: coverType?.code
                    ? coverType?.code?.toString()
                    : '',
                };
              }),
          },
          {
            type: 'select',
            disabled: values?.quotationNo !== '',
            label: (
              <div>
                Sum Insured <Text severity="error">*</Text>
              </div>
            ),
            iconPre: (
              <Text
                className={
                  values?.quotationNo !== ''
                    ? 'text-neutral-darker'
                    : 'text-info'
                }
              >
                {branding.currency}
              </Text>
            ),
            name: 'cover.sum_insured',
            data: applicableSumInsureds.map((sumInsured) => {
              return {
                label: `${CurrencyFormater(
                  sumInsured,
                  false,
                  true,
                  branding,
                  false,
                )}`,
                value: sumInsured ? sumInsured?.toString() : '',
              };
            }),
            className:
              values?.quotationNo !== '' ? 'border-neutral-dark' : '',
          },
          {
            type: 'select',
            disabled: values?.quotationNo !== '',
            label: (
              <div>
                Tenure <Text severity="error">*</Text>
              </div>
            ),
            name: 'cover.tenure',
            data: applicableTenures.map((tenure) => {
              return {
                label: tenure?.value ? tenure?.value?.toString() : '',
                value: tenure?.code ? tenure?.code?.toString() : '',
              };
            }),
          },
        ],
      },
      {
        title: 'Additional Details for Discounts',
        grid_data: [
          {
            type: 'text',
            label: (
              <Text type="label">
                Does customer already have existing policy with us?
              </Text>
            ),
            name: 'existingPolicyNumber',
            disabled: values?.quotationNo !== '',
            placeholder: 'Enter existing Policy Number',
            colSpan: repeat === repeatForDesktop ? 2 : repeat,
            size: `${
              repeat === repeatForDesktop ? 'medium' : 'full'
            }`,
            className: `${repeat === repeatForDesktop ? 'w-60' : ''}`,
          },
          {
            type: 'radiogroup',
           
            label:
              'Is the customer also an internal employee or staff of us?',
            name: 'isExistingEmployee',
            disabledGlobal: values?.quotationNo !== '',
            data: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
            colSpan: repeat,
          },
        ],
      },
    ];


    const other_props = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
    };

    return (
      <div>
        <QuantaForm className="space-y-4">
          <InputGridGroup {...{ data, ...other_props }} />
        </QuantaForm>
        <QuantaForm>
          <ModalAddOthers
            {...{
              setShowModalAddOthers,
              showModalAddOthers,
              applicableMemberTypes,
              genderList,
              memberList,
              setMemberList,
              values,
              setFieldValue,
              productCode,
              productName,
              lobCode,
              quoteNumber,
            }}
          />
        </QuantaForm>
      </div>
    );
  };

  const initialValues = {
    show_plans: healthQuote?.show_plans,
    quotationNo: healthQuote?.quotationNo,
    quotationType: healthQuote?.quotationType
      ? healthQuote?.quotationType
      : businessTypeList && businessTypeList?.length > 0
      ? businessTypeList[0]?.code
      : '',
    quotationStatus: healthQuote?.quotationStatus,
    quoteCreationDate: healthQuote?.quoteCreationDate,
    proposalNumber: healthQuote?.proposalNumber,
    members: healthQuote?.members,
    location: {
      pincode: healthQuote?.location?.pincode,
      state: healthQuote?.location?.state,
      district: healthQuote?.location?.district,
      city: healthQuote?.location?.city,
      zone: healthQuote?.location?.zone
        ? healthQuote?.location?.zone
        : applicableZones && applicableZones?.length > 0
        ? applicableZones[0]?.code
        : '',
    },
    isExistingEmployee: healthQuote?.isExistingEmployee,
    existingPolicyNumber: healthQuote?.existingPolicyNumber,
    cover: {
      type: healthQuote?.cover?.type,
      sum_insured: healthQuote?.cover?.sum_insured
        ? healthQuote?.cover?.sum_insured
        : applicableSumInsureds && applicableSumInsureds?.length>0
        ?applicableSumInsureds[2].toString()
        :'' ,
      tenure: healthQuote?.cover?.tenure
        ? healthQuote?.cover?.tenure
        : applicableTenures && applicableTenures?.length > 0
        ? applicableTenures[0]?.code
        : '',
    },
    customer: healthQuote?.customer,
    customerMeta: healthQuote?.customerMeta,
  };

  return (
    <div>
      {initialValues && (
        <QuantaFormik
          enableReinitialize={true}
          {...{
            innerRef: props.forwardedRef,
            initialValues,
            validate,
            onSubmit,
            validator: () => ({}),
          }}
        >
          <MemberForm {...{ validate }} />
        </QuantaFormik>
      )}
    </div>
  );
}
